<h1 mat-dialog-title>Scan</h1>
<div mat-dialog-content>
  <div>
    <p>{{ displayMessage }}</p>
    @if (showProgress) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
<div mat-dialog-actions align="end">
  @if (showScanActions) {
    <button mat-button (click)="continueScanning()">
      {{ 'YES' | transloco }}
    </button>
    <button mat-button (click)="completeScan()">{{ 'NO' | transloco }}</button>
  }
</div>
